<template>
  <div>
    <div class="card mb-3 w-100">
      <p class="card-titulo font-weight-bold p-2 h5"> 
        Fechamento 
      </p>
      <div v-for="dados in dadosDoCard" 
           :key="dados.titulo" 
           class="card-conteudo mr-3 ml-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            {{ dados.titulo }} <br>
          </div>
          <div class="card-valor font-weight-bold text-left">
            <input v-money="money"
                   :value="dados.total"
                   disabled
                   size="sm"
                   trim>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { VMoney } from 'v-money'

  export default {
    name: "CardFechamento",
    directives: {
      money: VMoney
    },
    props: {
      propPedidos: {type: Object, default: () =>{}},
      propPagamentosAvulso: {type: Object, default: () =>{}},
    },
    data () {
      return {
        dadosDoCard: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    computed: {
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
    },
    watch: {
      'cxSaldo.pedidos.saldoTotal' () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.dadosDoCard = []
        this.dadosDoCard.push(this.cxSaldo.pedidos.os)
        this.dadosDoCard.push(this.cxSaldo.pedidos.avulsos)
        this.dadosDoCard.push(this.cxSaldo.pagamentosAvulso)
      }
    }
  }
</script>

<style scoped>
    .card {
        box-shadow: 3px 3px 0px rgba(0, 0, 0, 0.3);
    }
    .card .card-titulo {
        background-color: #C6C6C6;
    }
    .card .card-conteudo .card-valor{
        font-size: 1.3rem;
    }
    /* .card-valor input {
      font-size: 1.3rem;
      font-weight: bold;
      width:200px;
      padding-left:30px;
    } */
     .card-valor input {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: right;
      margin-right: 20px;
      width:100%;
    }
</style>